export default __webpack_public_path__ + "assets/lavoisier-component.78dad449.svg";